import { Payout } from '@models/betSlip/Payout';
import CalculationHelper from '@core/services/betSlip/CalculationHelper';
import TaxService from '@core/services/betSlip/TaxService';
import ILottoBetSlipState from '../types';

const STAKE_NUMBER_OF_DECIMALS = 8;

export default {
    payout(state: ILottoBetSlipState): Payout {
        return state.payout;
    },

    payoutSummary: (state: ILottoBetSlipState, getters: any) => (
        {
            stake: getters.stakeAfterTax,
            tax: TaxService.getInstance().getStakeTaxByPurchaseType(getters.purchaseType),
            combinations: getters.totalNumberOfSelectedCombinations,
        }
    ),

    stakeAfterTax(state: ILottoBetSlipState, getters: any): number {
        const taxService = TaxService.getInstance();
        return CalculationHelper.round(
            taxService.getStakeAfterDeductions(
                getters.stake,
                getters.purchaseType,
            ),
            STAKE_NUMBER_OF_DECIMALS
            );
    },

    taxPercentage(state: ILottoBetSlipState) {
        return TaxService.getInstance().getStakeTaxByPurchaseType(state.purchaseType);
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/betSlip/getters/summary.ts